export default "__VITE_ASSET__41d0ad23__"